// extracted by mini-css-extract-plugin
export default {"chatPageChat3":"Chat3_chatPageChat3__sUMPS"};